import React from "react";
import ReactDOM from "react-dom/client";
import { initErrorReporting } from "@/utils/errorReporter";
import { ThemeProvider } from "@/hooks/useTheme";
import { AuthProvider } from "@/contexts/AuthContext";
import { PersonaProvider } from "@/contexts/PersonaContext";
import { StreamProvider } from "@/contexts/StreamContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import App from "./App";

// Initialize global error reporting
initErrorReporting();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <StreamProvider>
            <PersonaProvider>
              <App />
            </PersonaProvider>
          </StreamProvider>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
